import React, { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryFallBack from './components/custom/fallback-view/error-boundary-fallback';
import LoadingFallback from './components/custom/fallback-view/loading-fallback';
import './index.css';
import RootApp from './root-app';
import ReactReduxProvider from './redux/react-redux-provider';

const CustomQueryClientProvider = React.lazy(
  () => import('./lib/query-client/query-client-provider'),
);

const el = document.getElementById('root')!;

const init = () => {
  return (
    <StrictMode>
      <ErrorBoundary fallback={<ErrorBoundaryFallBack />}>
        <Suspense fallback={<LoadingFallback />}>
          <CustomQueryClientProvider>
            <ReactReduxProvider>
              <RootApp />
              {/* <ReactQueryDevtools
                initialIsOpen={false}
                buttonPosition="bottom-right"
              /> */}
            </ReactReduxProvider>
          </CustomQueryClientProvider>
        </Suspense>
      </ErrorBoundary>
    </StrictMode>
  );
};

createRoot(el).render(init());
